// extracted by mini-css-extract-plugin
module.exports = {"cursor":"ReloveIconUser_cursor__3s5Io","root":"ReloveIconUser_root__2_lI5"};